import { useCallback, useRef } from 'react';

/**
 * Throttle call function in a time
 */
export const useThrottle = (
  func: (...params: any[]) => any,
  limit: number,
  time: number,
  dependencies: Array<any> = [],
) => {
  const count = useRef<number>(0);
  const inThrottleTime = useRef<boolean>(false);
  const newFunc = useCallback((...params: any) => {
    if (!inThrottleTime.current) {
      func(...params);
      count.current++;
      inThrottleTime.current = true;
      setTimeout(() => {
        inThrottleTime.current = false;
        count.current = 0;
      }, time);
    } else {
      if (count.current < limit) {
        count.current++;
        func(...params);
      }
    }
  }, dependencies);
  return newFunc;
};
